// extracted by mini-css-extract-plugin
module.exports = {"PowerOceanA":"PowerOceanA_PowerOceanA__s8woW"};